import React, { PureComponent } from 'react'
import { View, TextInput, Image } from 'react-native'
import Constants from 'expo-constants'
import styled from 'styled-components/native'
import dateFormat from 'dateformat'

import { Text } from '../../Atoms/Typography'
import Button from '../../Atoms/Button'
import Touchable from '../../Atoms/Touchable'
import InlineError from '../../Atoms/InlineError'

import OptionsAlert from '../../Molecules/OptionsAlert'

import theme from '../../../styles/theme'

const source = require('../../../assets/excelerate-logo.png')

const Container = styled(View)`
  flex: 1;
  background-color: ${theme.colours.black};
`

const Body = styled(View)`
  flex: 1;
  padding: ${3 * theme.gutterUnit}px;
  background-color: ${theme.colours.black};
  align-items: center;
  justify-content: center;
`

const Input = styled(TextInput)`
  height: 50px;
  width: 300px;
  border-color: ${theme.colours.white};
  background-color: ${theme.colours.white};
  border-width: 1px;
  border-radius: 5px;
  margin: ${theme.gutterUnit}px 0;
  padding: ${2 * theme.gutterUnit}px;
`

const Logo = styled(Image)`
  width: 282px;
  height: 144px;
`

const Footer = styled(View)`
  height: 60px;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
`

const ChangeEventRow = styled(View)`
  margin-top: ${theme.gutterUnit}px;
  flex-direction: row;
`

const getErrorMessage = (error) => {
  if (error.errors && error.errors[0].path) {
    return error.errors[0].path + ': ' + error.errors[0].message
  }
  return error.message
}

const formatEventName = (e) => {
  let endBit = ''
  if (e.streamName) {
    endBit = ` - ${e.streamName}`
  }
  return `${e.gameName} (${dateFormat(e.date, 'dd mmm yyyy')}${endBit})`
}

class LoginForm extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      password: '',
      error: '',
      eventId: null
    }
  }

  componentDidUpdate (prevProps) {
    if (
      prevProps.error !== this.props.error
    ) {
      this.setState({ error: this.props.error })
    }
    if (!prevProps.selectedEventId && this.props.selectedEventId) {
      this.setState({ eventId: this.props.selectedEventId })
    }
  }

  handleConfirmPress = () => {
    this.props.onLogin({ email: this.state.email, password: this.state.password, eventId: this.state.eventId })
  }

  handleNextPress = () => {
    this.props.fetchEvents({ email: this.state.email })
  }

  handleEventSelect = (eventId) => {
    this.setState({ eventId, error: null })
  }

  handleEmailChange = (val) => {
    this.setState({ email: val, error: null })
  }

  handlePasswordCHange = (val) => {
    this.setState({ password: val, error: null })
  }

  handleSigninDifferentAccount = () => {
    this.setState({ error: null, eventId: null })
    this.props.onClearEmail()
  }

  renderEnterEmail = () => {
    const buttonEnabled = !this.props.isFetchingEvents && this.state.email
    return (
      <>
        {!!this.props.errorFetchingEvents && (
          <InlineError message={this.props.errorFetchingEvents.message} />
        )}
        <Input
          data-test='Email'
          onChangeText={this.handleEmailChange}
          value={this.state.email}
          placeholder='Email'
          autoCorrect={false}
          underlineColorAndroid='transparent'
        />
        <Button
          data-test='Next'
          primary={buttonEnabled}
          darkgrey={!buttonEnabled}
          rounded
          onPress={this.handleNextPress}
          disabled={!buttonEnabled}
          styles={[{ width: 300, marginTop: theme.gutterUnit, padding: 2 * theme.gutterUnit, height: 50 }]}
        >
          <Text size='s' white>Next</Text>
        </Button>
      </>
    )
  }

  renderEmailAndPassword = () => {
    const buttonEnabled = !this.props.isLoading && this.state.email && this.state.password
    const selectedEventId = this.state.eventId
    const selectedEvent = this.props.events.find(e => e.id === selectedEventId)
    return (
      <>
        {!(selectedEventId) && (
          <OptionsAlert
            visible
            title='You are registered for multiple events. Select one:'
            options={this.props.events.map(e => {
              return {
                value: e.id,
                name: formatEventName(e),
                handlePress: () => this.handleEventSelect(e.id),
                selected: e.id === selectedEventId
              }
            })}
          />
        )}
        {!!selectedEventId && (
          <Text overrides={{ marginBottom: theme.gutterUnit }} size='xs' colour={theme.colours.white}>Signing into {selectedEvent.gameName}</Text>
        )}
        <Input
          data-test='Email'
          onChangeText={this.handleEmailChange}
          value={this.state.email}
          placeholder='Email'
          autoCorrect={false}
          disabled
          underlineColorAndroid='transparent'
        />
        <Input
          data-test='Password'
          onChangeText={this.handlePasswordCHange}
          value={this.state.password}
          placeholder='Password'
          autoCorrect={false}
          secureTextEntry
          underlineColorAndroid='transparent'
        />
        <Button
          data-test='Login'
          primary={buttonEnabled}
          darkgrey={!buttonEnabled}
          rounded
          onPress={this.handleConfirmPress}
          disabled={!buttonEnabled}
          styles={[{ width: 300, marginTop: theme.gutterUnit, padding: 2 * theme.gutterUnit, height: 50 }]}
        >
          <Text size='s' white>Login</Text>
        </Button>
        {this.props.events.length > 1 && (
          <ChangeEventRow>
            <Touchable onPress={() => this.handleEventSelect(null)} data-test='ChangeEvents'>
              <Text size='xs' link colour={theme.colours.primary}>Sign into a different event</Text>
            </Touchable>
          </ChangeEventRow>
        )}
        <ChangeEventRow>
          <Touchable onPress={this.handleSigninDifferentAccount} data-test='ChangeEmail'>
            <Text size='xs' link colour={theme.colours.primary}>Sign in with a different account</Text>
          </Touchable>
        </ChangeEventRow>
      </>
    )
  }

  render () {
    const { events } = this.props
    const renderer = !events.length ? this.renderEnterEmail : this.renderEmailAndPassword

    return (
      <Container>
        <Body>
          <Logo source={source} resizeMode='contain' />
          {!!this.state.error && <InlineError message={getErrorMessage(this.state.error)} />}
          {renderer()}
        </Body>
        <Footer>
          <Text size='l' bold white>Version: {Constants.manifest.version}</Text>
        </Footer>
      </Container>
    )
  }
}

export default LoginForm
